import { render, staticRenderFns } from "./coachBind.vue?vue&type=template&id=51ddcb94&scoped=true&"
import script from "./coachBind.vue?vue&type=script&lang=js&"
export * from "./coachBind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ddcb94",
  null
  
)

export default component.exports